import { DoseInputError } from './doseFactor';

// Voxel-wise sum (Gy) of doses already on one grid, accumulated in input order.
export function doseSumGy(doses: readonly Float32Array[]): Float32Array {
    const length = doses[0]?.length;
    if (length === undefined || doses.some((dose) => dose.length !== length)) {
        throw new DoseInputError(
            'Doses to sum must share one grid.',
            'dose.error.notOneGrid'
        );
    }
    const accumulated = new Float64Array(length);
    for (const dose of doses) {
        for (let i = 0; i < length; i++) {
            accumulated[i] += dose[i];
        }
    }
    return Float32Array.from(accumulated);
}
